import { useEffect } from "react";
import { useSelector } from "react-redux";
//import { CreateUserEntity } from "../../../../../entities/ServicesEntities/UserEntities/CreateUserEntity";
import { StepHeaderEntity } from "../../../../../entities/UIEntities/Form Entities/StepHeaderEntity";
import { ADD_PARKER_FORM_STEPS } from "../../../../../enums/Enums";
import { commonActions } from "../../../../../redux/reducers/CommonReducer";
import store from "../../../../../redux/Store";
import Icons from "../../../../../resources/icons/Icons";
import Strings from "../../../../../resources/Strings";
import { phoneNumberToSend, getProgressBarValue } from "../../../../../utils/CommonUtils";
import FacilitySummaryAccordion from "../../../Accordion/FacilitySummaryAccordion/FacilitySummaryAccordion";
import PageAvatarInfo from "../../../Avatar/PageAvatarInfo/PageAvatarInfo";
import classes from "../WizardForm.module.css";

const SummaryStep = (props) => {
  const site = useSelector((state) => state.user.sites).find(
    (site) => site.id === props.site
  );
  const userType = useSelector(
    (state) => state.user?.initialState?.userTypes
  ).find((userType) => userType.id === props.userType);

  useEffect(() => {
    if (props.currentStep === ADD_PARKER_FORM_STEPS.SUMMARY) {
      const stepHeader = new StepHeaderEntity(
        "Create New Parker",
        "Step 5",
        Icons.NEW_PARKER,
        getProgressBarValue(ADD_PARKER_FORM_STEPS.SUMMARY)
      );

      store.dispatch(commonActions.setSideModal({ modalHeader: stepHeader }));
    }
  }, [props.currentStep]);

  if (props.currentStep !== ADD_PARKER_FORM_STEPS.SUMMARY) {
    return null;
  }

  return (
    <div className={classes.stepContainer}>
      <PageAvatarInfo
        name={`${props.firstName} ${props.lastName}`}
        image={props.profilePicture}
        sizeClass="big"
        hasAppBadge={props.app}
      ></PageAvatarInfo>
      <div className={classes.personalDetails}>
        <div className={classes.detailItem}>
          <img src={Icons.PHONE} />
          <span className={classes.detailText}>+{props.dialingCode + phoneNumberToSend(props.dialingCode, props.phoneNumber)}</span>
        </div>
        <div className={classes.detailItem}>
          <img src={Icons.EMAIL} />
          <span className={classes.detailText}>{props.email}</span>
        </div>
      </div>

      <span className={classes.subTitle}>
        {Strings.USER_INFO.FACILITY_AND_CAR}
      </span>
      <FacilitySummaryAccordion site={site} userType={userType} carUserTokens={props?.carUserTokens} />
    </div>
  );
};

export default SummaryStep;
